var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-btn d-flex align-items-center justify-content-center",class:_vm.noHover ? ' no-hover' : ' hover',style:(_vm.css)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }